import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const ACCORDION_ARROW = '/static/images/menu/header-abn/accordion-arrow.svg';

export const Wrapper = styled.div<{ isAvailable: boolean, open: boolean }>`
  background-color: ${COLORS.BgMain};
  border-radius: unset;
  border: none;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;
  display: ${props => props.isAvailable ? 'flex' : 'none'};
  max-height: ${props => props.open ? '100%' : '56px'};
`;

export const LinkItemDrop = styled.a<{ open: boolean, isPromoted: boolean }>`
  ${FONTS.MediumS};
  color: ${COLORS.TextPrimary};
  color: ${props => props.open
      ? props.isPromoted
          ? COLORS.Logo
          : COLORS.TextHint
      : props.isPromoted
          ? COLORS.Logo
          : COLORS.TextPrimary
  };
  flex-grow: 1;
  width: calc(100% - 53px);
`;

export const AccordionTitle = styled.div<{ open: boolean }>`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: ${props => props.open ? '8px' : '0'};
  cursor: pointer;
  color: ${COLORS.TextPrimary};
  ${FONTS.MediumS};  
  border-bottom: 2px solid ${COLORS.BgSecondary};
  padding: 12px 0;
`;

export const Title = styled.div``;

export const Icon = styled.span<{ open: boolean, isVisible: boolean }>`
  margin-left: 20px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: ${props => props.isVisible ? 'block' : 'none'};
  position: relative;
  background-color: ${props => props.open ? COLORS.ButtonSecondary : '#F4F8FB'};
  transform-origin: center;

  &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: url(${ACCORDION_ARROW});
      background-repeat: no-repeat;
      background-position: center;
      transform: ${props => props.open ? 'scaleY(-1)' : 'none'};
      transition: transform 0.5s;
  }
`;

export const AccordionBody = styled.div<{ open: boolean }>`
  width: 100%;
  max-height: ${props => props.open ? '100%' : '0'};
  ${FONTS.S};
  overflow: hidden;
  opacity: ${props => props.open ? 1 : 0};
  transition: opacity 0.2s ease-in-out;

  @media (max-width: ${wideBreakpoints.mobile}) {
      ${FONTS.XS};
  }
`;
